var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "menu-button",
    width: 111,
    height: 128,
    viewBox: "0 0 111 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.86867 94.3448V33.6552L55.4227 3.31618L107.977 33.6552V94.3448L55.4227 124.684L2.86867 94.3448Z",
    fill: "#C0BDC1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4227 6.62089L105.108 35.3076V92.6809L55.4227 121.368L5.73734 92.6809V35.3076L55.4227 6.62089ZM55.4227 0L52.554 1.65235L2.86867 30.339L0 31.9914V95.9857L2.86867 97.638L52.554 126.325L55.4227 127.977L58.2913 126.325L107.977 97.638L110.845 95.9857V32.0029L107.977 30.3505L58.2913 1.65235L55.4227 0Z",
    fill: "#262541"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.108 92.6809L83.6045 79.9555L88.9746 44.5332L105.108 35.3076V92.6809Z",
    fill: "#979397"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4227 121.368L57.5111 101.057L83.6045 79.9555L105.108 92.6809L55.4227 121.368Z",
    fill: "#AFACB0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.246 78.1884L5.73734 92.6809L55.4227 121.368L57.5111 101.057L24.246 78.1884Z",
    fill: "#979397"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.73734 92.6809L24.246 78.1884L22.192 40.6892L5.73734 35.3076V92.6809Z",
    fill: "#5D5E60"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.192 40.6892L55.4227 24.6361V6.62089L5.73734 35.3076L22.192 40.6892Z",
    fill: "#D2D0D2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4227 24.6361L88.9746 44.5332L105.108 35.3076L55.4227 6.62089V24.6361Z",
    fill: "#5D5E60"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuButton);
export default __webpack_public_path__ + "static/media/menu-button.28d2aac4c333f5213b85b681c5311b4b.svg";
export { ForwardRef as ReactComponent };